import React, { useEffect, useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, message, Upload } from 'antd';
import { getUser, request, setUser } from "@/utils";
import Config from "@/config/config";
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import icon_close from '@/assets/icon_close.png'


const AliyunOSSUploadImg = ({ value, onChange, type }) => {
    const [loading, setLoading] = useState(false);
    const [OSSData, setOSSData] = useState();
    const [fileList, setFileList] = useState([]);

    const getSTSData = async () => {
        try {
            const response = await request.get('tool/sts-token?type=image',);
            if (response.code) {
                message.error(response.ret.cn)
            } else {
                const tmpObj = response.data
                let storage = "";
                if (type) {
                    storage = type;
                }
                const data = {

                    "accessId": tmpObj.access_key_id,
                    "host": Config.imgPrefix,
                    "policy": tmpObj.policy,
                    "signature": tmpObj.signature,
                    "securityToken": tmpObj.security_token,
                    "dir": "reservation/" + storage + "/",
                };
                return data;
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    }

    const init = async () => {
        try {
            const result = await getSTSData();
            setOSSData(result);
        } catch (error) {
            message.error(error);
        }

    };
    useEffect(() => {
        init();
    }, []);


    const handleChange = ({ file, fileList: newFileList }) => {
        setFileList([...newFileList]);
        // 上传完成时通知父组件
        if (file.status === 'done') {
            const formattedList = newFileList
                .map(f => ({
                    uid: f.uid,
                    name: f.name,
                    url: f.response?.url || f.url
                }));
            onChange?.(formattedList);
            setLoading(false);
        } else if (file.status === 'uploading') {
            setLoading(true);
        }
    };

    const getExtraData = (file) => ({
        key: file.url,
        OSSAccessKeyId: OSSData?.accessId,
        policy: OSSData?.policy,
        Signature: OSSData?.signature,
        "x-oss-security-token": OSSData.securityToken,

    });
    const beforeUpload = async (file) => {
        const MAX_SIZE = 10 * 1024 * 1024; // 10MB
        if (file.size > MAX_SIZE) {
            message.error('图片大小不能超过10MB');
            return Upload.LIST_IGNORE; // 返回 Upload.LIST_IGNORE 会让文件不显示在上传列表中
        }
        if (!OSSData) return false;
        const expire = Number(OSSData.expire) * 1000;
        if (expire < Date.now()) {
            await init();
        }
        const suffix = file.name.slice(file.name.lastIndexOf('.'));
        const filename = Date.now() + suffix;
        // @ts-ignore
        file.url = OSSData.dir + filename;
        return file;
    };

    const onRemove = (file) => {
        const newFileList = fileList.filter(item => item.uid !== file.uid);
        setFileList(newFileList);
        onChange?.(newFileList);
    };

    const uploadProps = {
        name: 'file',
        fileList: value,
        action: OSSData?.host,
        onChange: handleChange,
        onRemove,
        data: getExtraData,
        beforeUpload,

    };
    const uploadButton = (
        <button style={{ border: 0, background: 'none', color: '#999999' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>上传图片({3 - fileList?.length})</div>
        </button>
        // <button
        //     style={{
        //         width: "120px",
        //         height: "120px",
        //         // border: "1px dashed #999999",
        //         border: "1px dashed #F7F7F7",
        //         background: 'none',
        //         backgroundColor: "#F7F7F7",
        //         color: "#999999",
        //     }}
        //     type="button"
        // >
        //     {/* {loading ? <LoadingOutlined /> : <PlusOutlined />} */}
        //     <PlusOutlined />
        //     <div
        //         style={{
        //             marginTop: 8,
        //         }}
        //     >
        //         上传图片({3 - fileList?.length})
        //     </div>
        // </button>
    );

    return (
        <Upload
            {...uploadProps}
            showUploadList={{
                showPreviewIcon: false // 隐藏预览图标
            }}
            listType="picture-card"
            fileList={fileList}
            onChange={handleChange}
            accept="image/*" // 只允许上传图片类型文件
        >
            {fileList.length >= 3 ? null : uploadButton}
        </Upload>
    );
};
export default AliyunOSSUploadImg
